import React, { useState, useEffect, useRef } from 'react';
import { Plus } from 'lucide-react';

export default function SearchSelect({ value, onChange, options, placeholder, onAdd, addLabel, testId }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = query
    ? options.filter(o => o.toLowerCase().includes(query.toLowerCase()))
    : options;
  const showAdd = onAdd && query.trim().length >= 2 && !options.some(o => o.toLowerCase() === query.toLowerCase());

  return (
    <div ref={ref} className="relative" data-testid={testId}>
      <input
        type="text"
        value={open ? query : value}
        onFocus={() => { setOpen(true); setQuery(value); }}
        onChange={e => { setQuery(e.target.value); setOpen(true); }}
        placeholder={placeholder}
        className="w-full bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-xs outline-none focus:border-primary/50 placeholder:text-muted-foreground/40"
      />
      {open && (
        <div className="absolute z-30 top-full mt-1 w-full max-h-40 overflow-y-auto bg-bg-paper border border-white/10 rounded-xl shadow-xl">
          {filtered.slice(0, 30).map(o => (
            <button
              key={o}
              type="button"
              onClick={() => { onChange(o); setOpen(false); setQuery(''); }}
              className={`w-full text-left px-3 py-1.5 text-xs hover:bg-white/5 transition-colors ${o === value ? 'text-primary' : 'text-muted-foreground'}`}
            >
              {o}
            </button>
          ))}
          {filtered.length === 0 && !showAdd && (
            <p className="px-3 py-2 text-[10px] text-muted-foreground/40">no matches</p>
          )}
          {showAdd && (
            <button
              type="button"
              onClick={() => { onAdd(query.trim()); setOpen(false); setQuery(''); }}
              className="w-full text-left px-3 py-2 text-xs text-secondary border-t border-white/5 hover:bg-secondary/5 transition-colors flex items-center gap-1"
            >
              <Plus className="w-3 h-3" /> {addLabel || 'Add'} "{query.trim()}"
            </button>
          )}
        </div>
      )}
    </div>
  );
}
